import React from 'react';
import { AlertTriangle, Clock, ArrowRight } from 'lucide-react';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const PendingInvestigationsPanel = ({ overdueCount, incidents }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <AlertTriangle className="w-8 h-8 text-red-600" />
        </div>
        
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-red-900 mb-2">
            Pending Investigations Requiring Attention
          </h3>
          <p className="text-sm text-red-800 mb-4">
            {overdueCount} incident{overdueCount !== 1 ? 's' : ''} {overdueCount !== 1 ? 'have' : 'has'} overdue investigations that require immediate attention
          </p>
          
          <div className="space-y-3 mb-4">
            {incidents?.slice(0, 3)?.map((incident) => (
              <div 
                key={incident?.id} 
                className="bg-white rounded-lg p-4 border border-red-200"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-sm font-semibold text-gray-900">{incident?.id}</span>
                      <span className="text-xs text-gray-600">•</span>
                      <span className="text-sm text-gray-700">{incident?.classification}</span>
                    </div>
                    <p className="text-sm text-gray-600 mb-2">{incident?.description}</p>
                    <div className="flex items-center gap-4 text-xs text-gray-600">
                      <span className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {incident?.daysOpen} days open
                      </span>
                      <span>{incident?.location}</span>
                      <span>Assigned: {incident?.investigator}</span>
                    </div>
                  </div>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => navigate(`/incident-details/${incident?.id}`)}
                    className="ml-4"
                  >
                    <ArrowRight className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <Button
            onClick={() => navigate('/incident-reporting-dashboard')}
            className="bg-red-600 hover:bg-red-700"
          >
            View All Overdue Incidents
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingInvestigationsPanel;